function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.333496 7.0835C0.333496 3.22803 3.45068 0.0834961 7.3335 0.0834961C11.189 0.0834961 14.3335 3.22803 14.3335 7.0835C14.3335 10.9663 11.189 14.0835 7.3335 14.0835C3.45068 14.0835 0.333496 10.9663 0.333496 7.0835ZM4.7085 7.9585C5.17334 7.9585 5.5835 7.57568 5.5835 7.0835C5.5835 6.61865 5.17334 6.2085 4.7085 6.2085C4.21631 6.2085 3.8335 6.61865 3.8335 7.0835C3.8335 7.57568 4.21631 7.9585 4.7085 7.9585ZM7.3335 6.2085C6.84131 6.2085 6.4585 6.61865 6.4585 7.0835C6.4585 7.57568 6.84131 7.9585 7.3335 7.9585C7.79834 7.9585 8.2085 7.57568 8.2085 7.0835C8.2085 6.61865 7.79834 6.2085 7.3335 6.2085ZM9.9585 7.9585C10.4233 7.9585 10.8335 7.57568 10.8335 7.0835C10.8335 6.61865 10.4233 6.2085 9.9585 6.2085C9.46631 6.2085 9.0835 6.61865 9.0835 7.0835C9.0835 7.57568 9.46631 7.9585 9.9585 7.9585Z",
  fill: "currentColor"
});

function SvgRoundedDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedDots);
export default __webpack_public_path__ + "static/media/rounded-dots.a05643b9.svg";
export { ForwardRef as ReactComponent };